import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchData = async (id) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.DEV_TEST_API;
  const requestData = {
    task: "latestRiskAssessment",
    patient_id: id,
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  if (response.data.length === 0 || response.data[0].risk_assessment === true) {
    return null;
  }
  return JSON.parse(response.data[0].risk_assessment);
};

export const useRiskAssessment = (id) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["latestRiskAssessment", id], // Unique key for this query
    queryFn: () => fetchData(id), // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
};
